module.exports = __webpack_public_path__ + "2fcae20298d19821d58ce81d7be110e4.pdf";